import { useState } from 'react';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import { AIMedia, AIMediaStatus, BrollCaptionVideo } from '../../@types';
import { handleDownloadVideoFile, MediaStatus } from '../../utils';
import { useDialog } from '../../hooks';
import { useDeleteBrollVideo } from '../../services/broll-videos/deleteVideo';
import { useCloneBrollCaption } from '../../services';

interface Props {
  initialData: AIMedia;
  refreshData: () => void;
  handleOnPreview: (_: string) => void;
}

export const useAiGenerationCardAction = ({ initialData, refreshData, handleOnPreview }: Props) => {
  const [videoData, setVideoData] = useState(initialData);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();

  const {
    isDialogOpen: isDeleteDialogOpen,
    openDialog: openDeleteDialog,
    closeDialog: closeDeleteDialog,
  } = useDialog();

  const { mutate: deleteVideo, isLoading: isDeletingVideo } = useDeleteBrollVideo();

  const confirmDeleteVideo = async () => {
    // deleteVideo(id, {
    //   onSuccess: () => {
    //     refreshData();
    //     enqueueSnackbar('Video deleted successfully', { variant: 'success' });
    //     closeDeleteDialog();
    //   },
    //   onError: () => {
    //     enqueueSnackbar('Error deleting video', { variant: 'error' });
    //   },
    // });
  };

  const initiateDownloadVideo = () => {
    // handleDownloadVideoFile({
    //   url: url,
    //   name,
    //   onSuccess: () => setMenuAnchorEl(null),
    // });
  };

  const menuActions = [
    {
      id: 'downloadVideo',
      label: 'Download',
      iconifyIcon: 'material-symbols:download',
      isHidden: videoData?.status !== AIMediaStatus.Success,
      onClick: initiateDownloadVideo,
    },
    {
      id: 'previewVideo',
      label: 'Preview',
      iconifyIcon: '',
      isHidden: videoData?.status !== AIMediaStatus.Success,
      onClick: () => {
        // handleOnPreview(renderedUrl);
        setMenuAnchorEl(null);
      },
    },
    {
      id: 'deleteVideo',
      label: 'Delete',
      iconifyIcon: 'material-symbols:delete',
      isHidden: videoData?.status !== AIMediaStatus.Success,
      onClick: openDeleteDialog,
    },
  ];

  return {
    menuAnchorEl,
    setMenuAnchorEl,
    isDeleteDialogOpen,
    closeDeleteDialog,
    confirmDeleteVideo,
    isDeletingVideo,
    menuActions,
    videoData,
  };
};
